import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="inline-block text-xs uppercase tracking-[0.2em] text-foreground-400 font-medium mb-4 border border-background-300/60 px-4 py-2 rounded-full">
            Категории
          </span>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 font-semibold mb-4">
            Все разделы магазина
          </h2>
          <p className="text-foreground-500 text-base max-w-xl mx-auto">
            Выберите интересующую вас категорию и перейдите к покупкам на kaspreadsheet.com
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5 flex flex-col items-center text-center hover:bg-background-100 transition-all duration-200 cursor-pointer"
            >
              <div className="w-11 h-11 rounded-full bg-background-100 flex items-center justify-center mb-3 group-hover:bg-accent-100 transition-colors">
                <i className="ri-shopping-bag-3-line text-foreground-500 text-lg group-hover:text-accent-600 transition-colors"></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-800 leading-tight text-center">
                {cat.name}
              </span>
              <span className="text-[10px] text-foreground-400 mt-1 opacity-0 group-hover:opacity-100 transition-opacity">
                Перейти →
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}